<template>
    <div class="order-item-wrapper">
        <div class="order-item-header-wrapper">
            <div class="create-time-wrapper">
                {{ item ? item.createdTime : '无创建日期' }}
            </div>
            <div class="order-no-wrapper">
                订单号: <a>{{ item.reservationNo }}</a>
            </div>
        </div>
        <div class="order-item-content-wrapper">
            <div style="width:25%" class="order-item-info-field">
                {{  item && item.ordersList && item.ordersList.length > 0 ? item.ordersList[0].sampleName : 'x0' }}
            </div>
            <div style="width:25%" class="order-item-info-field">
                {{ item && item.ordersList && item.ordersList.length > 0 ? 'x' + item.ordersList.length : 'x0' }}
            </div>
            <div style="width:25%" class="order-item-info-field">
                {{ item.entrustSumFee? '金额：' + item.entrustSumFee: '暂无计费'}}
            </div>
            <div :style="{width:'25%',color: orderStatus.color}" class="order-item-info-field">
                {{ orderStatus.name }}
            </div>
        </div>
        <div v-if="true" class="oprator-wrapper">
            <van-button @click="toEvaluate"  size="mini" plain type="info">评价</van-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderItem',
    props:{
        item:{
            type: Object,
            default: () => null
        }
    },
    computed: {
        orderStatus(){
            if(this.item && this.item.status){
                for (let i = 0; i < this.orderStatusList.length; i++) {
                    let element = this.orderStatusList[i];
                    if(element.code === this.item.status){
                        return element
                    }
                }
            }
            return '暂无信息'
        }
    },
    data(){
        return {
            orderStatusList: [
                {code: 'unSubmit', name: '未提交', color: '#ad8b00'},
                {code: 'cssDraft', name: '待认领 ', color: '#ad8b00'},
                {code: 'cssClaim', name: '已认领	', color: '#ad8b00'},
                {code: 'preDraft', name: '预受理	', color: '#ad8b00'},
                {code: 'contractReview', name: '合同评审	', color: '#ad8b00'},
                {code: 'draft', name: '新建', color: '#ad8b00'},
                {code: 'uncharge', name: '待收费', color: '#ad8b00'},
                {code: 'orderReceiving', name: '大厅发放样品', color: '#ad8b00'},
                {code: 'orderReceiving2', name: '实验室接受样品', color: '#ad8b00'},
                {code: 'cementCheck', name: '任务核对', color: '#ad8b00'},
                {code: 'cementApprove', name: '任务批准	', color: '#ad8b00'},
                {code: 'testing', name: '检测中', color: '#ad8b00'},
                {code: 'testDone', name: '检测完成	', color: '#ad8b00'},
                {code: 'done', name: '已完成', color: '#ad8b00'},
            ]
        }
    },
    methods:{
        toEvaluate(){
            const _this = this
            _this.$router.push({
                name: 'evaluate',
                params: {
                    item: _this.item
                }
            })
        },
    },
}
</script>

<style lang="scss">
.order-item-wrapper{
    /*display: flex;*/
    /*flex-direction: column;*/
    margin: 16px 16px 0;
    padding: 16px;
    box-sizing: border-box;
    background-color: #ffffff;

    .order-item-header-wrapper{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .order-no-wrapper{
            a {color: #2d8cf0;}
        }
    }

    .order-item-content-wrapper{
        display: flex;
        flex-direction: row;
        height: 48px;

        .order-item-info-field{
            height: 48px;
            line-height: 48px;
            text-align: center;
        }
    }

    .oprator-wrapper{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
}
</style>